<template >
  <div style="width: 100%">
    <el-tabs type="border-card">
      <el-tab-pane label="流程处理" >
        <h4>流程信息：</h4>
        <div class="box">
          <el-form :model="processData" label-width="150px" disabled>
            <el-row>
              <el-col :span="11" >
                <el-form-item label="流程编号：">
                  <el-input v-model="processData.id" placeholder="流程编号" />
                </el-form-item>
              </el-col>
              <el-col :span="11" >
                <el-form-item label="申请日期：">
                  <el-date-picker v-model="processData.create_time" type="date"
                                  value-format="YYYY-MM-DD" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11" >
                <el-form-item label="申请人：">
                  <el-input v-model="processData.create_user_name" placeholder="申请人" />
                </el-form-item>
              </el-col>
              <el-col :span="11" >
                <el-form-item label="申请部门：">
                  <el-input v-model="processData.create_user_name" placeholder="申请部门" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <h4>申请内容：</h4>
        <div class="box">
          <div v-for="(formData,index) in currentNodeFormDataList" :key="index">
            <FrameForm v-show="index===this.currentFormIdx" :component-param="formData.form_id" :readonly="true"
                       :key="formData.id" :init-data="formData"></FrameForm>
          </div>
        </div>
        <h4>领导审批：</h4>
        <div class="box">
          <el-form :model="processData" label-width="150px"  :disabled="taskActive">
            <el-row>
              <el-col :span="11" >
                <el-form-item label="审批结果：" required>
                  <el-select v-model="processData.review1_result">
                    <el-option v-for="item in auditResultList" :key="item.value" :label="item.name" :value="item.value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11" >
                <el-form-item label="审批人：">
                  <el-input v-model="processData.id" placeholder="审批人" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="22" >
                <el-form-item label="备注：">
                  <el-input type="textarea" v-model="processData.remark" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div v-if="processData.template_id ==='prc_business_trip'">
          <h4>反馈结果：</h4>
          <div class="box">
            <el-form :model="processData" label-width="150px">
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="反馈结果：" required>
                    <el-select v-model="processData.review1_result">
                      <el-option v-for="item in auditResultList" :key="item.value" :label="item.name" :value="item.value"/>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="详细说明：" required>
                    <el-input type="textarea" v-model="processData.remark" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="出差佐证照片：" required>
                    <FrameItem v-model="processData.image_id" :file-list="attach_photo_id_obj" :item="uploadImgObj" ></FrameItem>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="其他附件：">
                    <FrameItem v-model="processData.create_files" :file-list="attach_photo_id_obj" :item="uploadObj" ></FrameItem>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div v-if="processData.template_id ==='prc_business_trip' && this.travelType ==='prc_pre_sales_visit'">
          <h4>销售跟进记录：</h4>
          <div class="box">
            <el-form :model="processData" label-width="150px" :disabled="!taskActive">
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="序号：" required>
                    <el-input v-model="processData.remark" disabled/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="客户名称：" required>
                    <el-select v-model="processData.review1_result">
                      <el-option v-for="item in auditResultList" :key="item.value" :label="item.name" :value="item.value"/>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="机会编号：" required>
                    <el-select v-model="processData.review1_result">
                      <el-option v-for="item in auditResultList" :key="item.value" :label="item.name" :value="item.value"/>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="11" >
                  <el-form-item label="跟进日期：" required>
                    <el-date-picker v-model="processData.create_time" type="date"
                                    value-format="YYYY-MM-DD" style="width: 100%" />
                  </el-form-item>
                </el-col>
                <el-col :span="11" required>
                  <el-form-item label="跟进方式：">
                    <el-select v-model="processData.review1_result">
                      <el-option v-for="item in auditResultList" :key="item.value" :label="item.name" :value="item.value"/>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="跟进内容：">
                    <el-input type="textarea" v-model="processData.remark" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="11" >
                  <el-form-item label="下次跟进日期：">
                    <el-date-picker v-model="processData.create_time" type="date"
                                    value-format="YYYY-MM-DD" style="width: 100%" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="下次跟进内容：">
                    <el-input type="textarea" v-model="processData.remark" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div v-if="processData.template_id ==='prc_business_trip' && ['prc_after_sales_visit', 'prc_as_training'].includes(this.travelType)">
          <h4>售后工单填写：</h4>
          <div class="box">
            <el-form :model="processData" label-width="150px" :disabled="!taskActive">
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="序号：" required>
                    <el-input v-model="processData.remark" disabled/>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="客户名称：" required>
                    <el-select v-model="processData.review1_result">
                      <el-option v-for="item in auditResultList" :key="item.value" :label="item.name" :value="item.value"/>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="机会编号：" required>
                    <el-select v-model="processData.review1_result">
                      <el-option v-for="item in auditResultList" :key="item.value" :label="item.name" :value="item.value"/>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="标题：">
                    <el-input v-model="processData.remark" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="内容：">
                    <el-input type="textarea" v-model="processData.remark" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="11" >
                  <el-form-item label="联系日期：">
                    <el-date-picker v-model="processData.create_time" type="date"
                                    value-format="YYYY-MM-DD" style="width: 100%" />
                  </el-form-item>
                </el-col>
                <el-col :span="11" >
                  <el-form-item label="优先级：">
                    <el-select v-model="processData.review1_result">
                      <el-option v-for="item in auditResultList" :key="item.value" :label="item.name" :value="item.value"/>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="11" >
                  <el-form-item label="状态：" required>
                    <el-select v-model="processData.review1_result">
                      <el-option v-for="item in auditResultList" :key="item.value" :label="item.name" :value="item.value"/>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="11" >
                  <el-form-item label="技术担当：">
                    <el-select v-model="processData.review1_result">
                      <el-option v-for="item in auditResultList" :key="item.value" :label="item.name" :value="item.value"/>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="22" >
                  <el-form-item label="附件上传：">
                    <FrameItem v-model="processData.create_files" :file-list="attach_photo_id_obj" :item="uploadObj" ></FrameItem>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div v-if="processData.template_id ==='prc_business_trip'">
          <div style="display: flex; align-items: center;">
            <h4>出差费用填报：</h4>
            <el-switch v-model="tripCost" active-text="有出差费用" inactive-text="无" @change="initTripCost"/>
          </div>
          <div class="box" v-if="tripCost">
            <el-table stripe
                      ref="singleTableRef"
                :data="tripCostItems"
                style="width: 100%;margin-bottom: 10px"
                height="400px"
            >
              <el-table-column type="index" width="70" label="序号"/>
              <el-table-column property="name" label="项目" min_width="150"></el-table-column>
              <el-table-column property="money" label="金额(元)" width="150">
                <template #default="scope">
                  <el-input v-model="scope.row.money"
                            oninput="value=value.replace(/[^\d+(.\d+)?$]/g, '')" placeholder="0.00" clearable />
                </template>
              </el-table-column>
              <el-table-column property="remark" label="备注">
                <template #default="scope">
                  <el-input :disabled="this.readOnly" v-model="scope.row.remark" type="area"/>
                </template>
              </el-table-column>
            </el-table>
            <h4>出差成本分摊：</h4>
            <el-table stripe ref="singleTableRef"
                :data="tripCostItems"
                style="width: 100%;margin-bottom: 10px"
                height="350px"
            >
              <el-table-column type="index" width="70" label="序号"/>
              <el-table-column property="name" label="客户/公司" min_width="150"></el-table-column>
              <el-table-column property="money" label="机会编号" width="140">
                <template #default="scope">
                  <el-input-number :disabled="this.readOnly" style="width: 100%;"
                                   size="small" @change="countCompanyAll"
                                   v-model="scope.row.money" :min="0"
                                   controls-position="right" step="1000" precision="2"/>
                </template>
              </el-table-column>
              <el-table-column property="money" label="金额(元)" width="140">
                <template #default="scope">
                  <el-input-number :disabled="this.readOnly" style="width: 100%;"
                                   size="small" @change="countCompanyAll"
                                   v-model="scope.row.money" :min="0"
                                   controls-position="right" step="1000" precision="2"/>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="流程图">
        <div v-if="oldFlow" :id="containerId" ref="graph_container" class="graph_container"></div>
        <!--          <div v-if="oldFlow" :id="containerId" ref="graph_container" class="graph_container"></div>
                  <FramePrcRender v-else ref="prcRender" @node-click="nodeClick" class="graph_container"></FramePrcRender>-->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import {nextTick} from "vue";
import {mxConstants, mxEdgeStyle, mxEvent, mxGraph} from "mxgraph-js";

export default {
  name: "PrcHandleTab",
  components: {},
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      processData: {
        review1_result: 'prc_review_result_pass'
      },
      uploadImgObj: {
        component: 'image_upload',
        limit: 1,
      },
      uploadObj: {
        component: 'file_upload',
        limit: 10,
      },
      formDataList: [],
      currentNodeFormDataList: [],
      attach_photo_id_obj: [],
      currentNodeId: '',
      logs: [],
      taskActive: true,
      currentTaskForm: '',
      currentFormIdx: 0,
      nodes: [],
      routes: [],
      graph: {},
      containerId: new Date().getTime(),
      oldFlow: false,
      travelType:'',
      tripCost: false,
      tripCostItems: [],
    }
  },
  computed: {
    auditResultList() {
      return this.$store.getters['core/getDictList']('prc_review_result');
    },
    reimburseTypeList() {
      return this.$store.getters['core/getDictList']('reimburse_type');
    },
  },
  mounted() {
    this.loadPrcTaskInfo();
  },
  provide() {
    return {
      $fn: {
        reload: () => {
          this.afterBtnClick();
        }
      }
    }
  },
  methods: {
    afterBtnClick() {
      this.loadPrcTaskInfo();
    },
    async loadPrcTaskInfo() {
      if (!this.parentData || !this.parentData.id) {
        return this.$message.error(this.$t('check_page1'));
      }

      let params = {id: this.parentData.id}
      this.processData = await this.$http('prcService.getPrcTaskInfo', params)

      this.logs = this.processData?.logs || [];
      this.taskActive = this.processData?.task_active || false;

      if(this.processData?.form_data_list.length>0){
        this.travelType = this.processData?.form_data_list[0].travel_type
      }

      if (this.processData?.template?.edges) {
        this.oldFlow = false
        this.formDataList = this.processData.form_data_list;

        this.$refs.prcRender.render(this.processData.template);

        //默认显示第一个节点的表单内容
        if (this.formDataList.length > 0) {
          let formData = this.formDataList[0];
          this.currentNodeId = formData.node_id;
          this.setCurrentForms();
        }

      } else {
        this.oldFlow = true
        await nextTick()
        this.clearImage();
        this.drawProcess(this.processData);
      }
      //初始化任务表单
      if (this.taskActive) {
        this.currentTaskForm = this.processData.current_task_form;
        if (this.currentTaskForm) {
          this.$refs.currentTaskForm.initForm();
        }
      }
    },
    nodeClick(node) {
      if (node.properties?.finish) {
        this.currentNodeId = node.id
        this.setCurrentForms();
      }
    },
    getButtonClass(index) {
      if (this.currentFormIdx === index) {
        return "form_switch_button_active";
      }
      return "form_switch_button";
    },
    drawProcess(processData) {
      console.log("drawProcess start...")
      if (!processData) {
        return this.$message.error(`工作流数据为空！`);
      }

      this.processData = processData;
      let templateObj = processData.template;
      this.nodes = templateObj?.nodes || [];
      this.formDataList = processData.form_data_list;

      if (this.nodes.length == 0) {
        return;
      }

      this.drawImage();

      //默认显示第一个节点的表单内容
      if (this.formDataList.length > 0) {
        var formData = this.formDataList[0];
        this.currentNodeId = formData.node_id;
        this.setCurrentForms();
      }
    },
    setCurrentForms() {
      let cleared = false;
      if (!this.currentNodeId || this.currentNodeId.length === 0) {
        return;
      }
      for (let i = 0; i < this.formDataList.length; i++) {
        const formData = this.formDataList[i];
        if (formData.node_id && this.currentNodeId === formData.node_id) {
          if (!cleared) {
            this.currentNodeFormDataList.lenth = 0;
            this.currentNodeFormDataList = [];
          }
          cleared = true;
          this.currentNodeFormDataList.push(formData);
        }
      }

      this.currentFormIdx = this.currentNodeFormDataList.length - 1;

      //强制更新视图
      this.$forceUpdate();
    },
    drawImage() {
      console.log("drawImage start");
      // 创建画布
      var graph = new mxGraph(this.$refs.graph_container);
      this.graph = graph;

      graph.setEnabled(false); //设置启用,就是允不允许你改变CELL的形状内容。
      graph.setVertexLabelsMovable(false);

      // 设置鼠标悬停样式
      graph.getCursorForCell = function (cell) {
        if (cell !== null && cell.isFinishNode === true) {
          return 'pointer';
        }
      };

      var style = graph.getStylesheet().getDefaultEdgeStyle();
      style[mxConstants.STYLE_EDGE] = mxEdgeStyle.ElbowConnector; //自己拐弯的连线
      style[mxConstants.STYLE_FONTSIZE] = 16; //文字大小
      style[mxConstants.STYLE_FONTCOLOR] = "ff00ff";
      graph.getView().updateStyle = true; // 动态改变样式

      var parent = graph.getDefaultParent();
      //开始更新画布
      graph.getModel().beginUpdate();


      var that = this;
      //添加点击事件
      graph.addListener(mxEvent.CLICK, function (sender, evt) {
        //console.log('click in ...');
        var e = evt.getProperty('event'); // mouse event
        var cell = evt.getProperty('cell'); // cell may be null
        if (cell != null) {
          var id = cell.id;
          that.currentNodeId = cell.id
          console.log('that.currentNodeId=' + that.currentNodeId);
          that.setCurrentForms();
          evt.consume();
        }
      });

      try {

        // 插入节点
        var nodeObjects = {}
        for (var i = 0; i < this.nodes.length; i++) {
          var nodeData = this.nodes[i];
          var id = nodeData.id;

          var style = this.getNodeStyle(nodeData);
          var cell = graph.insertVertex(parent, null, nodeData.name, nodeData.x, nodeData.y, 100, 60, style);
          cell.id = id
          cell.name = nodeData.name;
          cell.isFinishNode = nodeData.finish;
          nodeObjects[id] = cell;
        }

        //插入线条
        for (var i = 0; i < this.nodes.length; i++) {
          var nodeData = this.nodes[i];
          var routes = nodeData.routes || [];
          for (var j = 0; j < routes.length; j++) {
            var routeData = routes[j];
            var fromId = routeData.source_node;
            var toId = routeData.target_node;

            if (nodeObjects[fromId] && nodeObjects[toId]) {
              var lineStyle = this.getRouteStyle(routeData);
              var hasBreakPoints = routeData.break_points && routeData.break_points.length > 0;
              var label = routeData.label || '';
              var edge = graph.insertEdge(parent, null, label, nodeObjects[fromId], nodeObjects[toId], lineStyle);
              //设置折线点
              if (hasBreakPoints) {
                edge.geometry.points = routeData.break_points
              }
            }
          }
        }
      } finally {
        // 画布更新结束
        graph.getModel().endUpdate();
      }
    },
    clearImage() {
      //var graph = this.graph;
      //开始更新画布
      //graph.getModel().beginUpdate();
      //graph.removeCells(graph.getChildVertices(graph.getDefaultParent())); //清空画布
      //graph.getModel().endUpdate();

      document.getElementById(this.containerId).innerHTML = "";
    },
    getNodeStyle(nodeData) {
      var style = 'fontSize=14';
      if (nodeData.current) {
        style = style + ';strokeColor=orange;strokeWidth=3';
      } else if (nodeData.finish) {
        style = style + ';strokeColor=#33cc66;strokeWidth=3';
      }

      if (nodeData.disabled) {
        style = style + ';fillColor=#aaa;strokeWidth=1';
      } else if (nodeData.fill_color) {
        style = style + ';strokeWidth=1;fillColor=' + nodeData.fill_color;
      }

      if (nodeData.start || nodeData.end) {
        style = style + ';rounded=1;perimeter=ellipsePerimeter;arcSize=30';
      }

      if (nodeData.font_color) {
        style = style + ';fontColor=' + nodeData.font_color;
      }
      return style;
    },
    getRouteStyle(routeData) {
      var normalStyle = 'edgeStyle=elbowEdgeStyle;';
      var activeStyle = 'edgeStyle=elbowEdgeStyle;strokeWidth=3;strokeColor=#33cc66';
      var lineStyle = normalStyle;
      if (routeData.finish) {
        lineStyle = activeStyle;
      } else if (routeData.color) {
        lineStyle = normalStyle + "strokeColor=" + routeData.color;
      }
      return lineStyle;
    },
    initTripCost(){
      this.reimburseTypeList.forEach((type)=>{
        let item = {
          id: Date.now(),
          item:type.value,
          name:type.name,
          money:0,
          remark:''
        }
        this.tripCostItems.push(item)
      });
      let item = {
        id: Date.now(),
        item:'sum',
        name:'合计',
        money:0,
        remark:''
      }
      this.tripCostItems.push(item)
    }
  },
}
</script>

<style scoped lang="less">
.box {
  padding-top: 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin: 10px 0;
}
</style>